const isIncludedIn = (reference = '', search = '') =>
  String(reference).toLowerCase().includes(search.toLowerCase());

export default isIncludedIn;
